module.exports = __webpack_public_path__ + "static/images/home-head-text.22fb308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-head-text.png
// module id = DBhi
// module chunks = 8